import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/mercari-sellers-guide';

export default function Example() {
  return (
    <>
      <Head>
        <title>Mercari Seller's Guide: The 3 Fastest Selling Categories</title>
        <meta name='description' content='Be on the lookout of these items while out sourcing for faster sales!' />
        <link rel='canonical' href='https://tools.oneshop.com/blog/mercari-sellers-guide' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/mercari-sellers-guide' />
        <meta property='og:title' content="Mercari Seller's Guide: The 3 Fastest Selling Categories" />
        <meta
          property='og:description'
          content='Be on the lookout of these items while out sourcing for faster sales!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
